import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type GithubAppInstallationNotFoundErrorOptions = {
  project?: ObjectId;
};

export class GithubAppInstallationNotFoundError extends FleekError<GithubAppInstallationNotFoundErrorOptions> {
  public name = 'GithubAppInstallationNotFoundError';

  toString = () => {
    return 'No GitHub App installation found for given project.';
  };
}
